var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeHigh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/volume-high"
  }, /*#__PURE__*/React.createElement("g", {
    id: "volume-high"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 9.93779C11.3044 9.33123 11.5 8.66248 11.5 7.93779C11.5 7.2031 11.3125 6.55029 11 5.93779M12.5 11.4378C13.1088 10.3753 13.5 9.43779 13.5 7.93779C13.5 6.43779 13.125 5.50966 12.5 4.43779M4.92656 5.93779H2.75C2.6837 5.93779 2.62011 5.96413 2.57322 6.01101C2.52634 6.05789 2.5 6.12148 2.5 6.18779V9.68779C2.5 9.75409 2.52634 9.81768 2.57322 9.86457C2.62011 9.91145 2.6837 9.93779 2.75 9.93779H4.92656C5.04212 9.93785 5.1541 9.97793 5.24344 10.0512L8.10188 12.395C8.13915 12.4224 8.1833 12.4389 8.22941 12.4427C8.27553 12.4465 8.32179 12.4375 8.36306 12.4166C8.40433 12.3956 8.43898 12.3637 8.46316 12.3242C8.48734 12.2848 8.50009 12.2394 8.5 12.1931V3.68247C8.49997 3.63626 8.48714 3.59095 8.46291 3.55159C8.43869 3.51223 8.40403 3.48035 8.36278 3.4595C8.32154 3.43865 8.27532 3.42964 8.22926 3.43348C8.1832 3.43731 8.13911 3.45384 8.10188 3.48122L5.24344 5.82498C5.15401 5.89804 5.04205 5.93791 4.92656 5.93779Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeHigh);
export default __webpack_public_path__ + "static/media/volume-high.3acc7ac762f13eb48945f12b61f95ed9.svg";
export { ForwardRef as ReactComponent };